































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

@Component({
  components: {
  },
})
export default class MelosSquareButton extends Vue {
  @Prop() private label!: string;
  @Prop() private image!: string;
  @Prop() private fallbackImage!: string;
  @Prop() private backgroundImage!: string;
  @Prop() private text!: string;
  @Prop() private checkable!: boolean;
  @Prop() private checkState!: boolean;
  private visibleLabelLength: number = 40;
  private forceFallback: boolean = false;

  private get visibleLabel(): string {
    return this.largeLabel ? this.getShortenLabel() : this.label;
  }

  private get largeLabel(): boolean {
    return (this.label || '').length > this.visibleLabelLength;
  }

  private getShortenLabel(): string {
    return `${(this.label || '').slice(0, this.visibleLabelLength)}...`;
  }

  private get checked(): boolean {
    return this.checkState;
  }

  private set checked(state: boolean) {
    this.$emit('checkStateUpdate', state);
  }

  private handleCheckboxUpdate(event: any) {
    this.checked = !this.checked;
    (event as any).preventDefault();
  }
}


